import Component, { mixins } from 'vue-class-component';
import VueCqrs from '@cqrs/vue-component-cqrs'
import PageBase from '@common/PageBase'
import * as q from './queries'

@Component
export default class VuePageQueries extends mixins(PageBase, VueCqrs) {
	runAuthUserWorkspacesEntriesQueryV1()
	{
		const query = q.buildAuthUserWorkspacesEntriesQueryV1()
		this.$query(query)
	}

	runAuthUserWorkspacesQueryV1()
	{
		const query = q.buildAuthUserWorkspacesQueryV1()
		this.$query(query)
	}

	runWorkspaceDetailsQueryV1(workspaceId: string)
	{
		const query = q.buildWorkspaceDetailsQueryV1(workspaceId)
		this.$query(query)
	}

	runWorkspaceInvitationQueryV1(token: string)
	{
		const query = q.buildWorkspaceInvitationQueryV1(token)
		this.$query(query)
	}

	runWorkspaceMembersQueryV1(workspaceId: string)
	{
		const query = q.buildWorkspaceMembersQueryV1(workspaceId)
		this.$query(query)
	}

	runWorkspacesByOrganizationQueryV1(tenantId: number)
	{
		const query = q.buildWorkspacesByOrganizationQueryV1(tenantId)
		this.$query(query)
	}

	runWorkspacesByUserQueryV1(userId: string)
	{
		const query = q.buildWorkspacesByUserQueryV1(userId)
		this.$query(query)
	}

}
